import { postRequest, EMAIL_SCHEDULING_PREFIX } from 'global/helpers/requests'
import { type SupportRequestFormValues } from './SupportRequestDialog'

export const supportRequest =  async (
  data: SupportRequestFormValues,
  weblinkToken?: string
) : Promise<void> => await postRequest<void>('support', { body: data, token: weblinkToken }, EMAIL_SCHEDULING_PREFIX)
